import {SnackbarProvider} from 'notistack'
import {FC, useEffect} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {ChangeRoomDocumentModel} from '../../../../models/change-rooms.model'
import {getBookingsChangeRoomsDocumentsService} from '../../../../services/change-rooms.service'

const TableChangeRoomsDocuments: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {currentTabItem} = useHoteleria()

  const getChangeRoomsDocuments = async () => {
    try {
      setLoading(true)
      const {data: response} = await getBookingsChangeRoomsDocumentsService(currentTabItem.idToEdit)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getChangeRoomsDocuments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    setLoading(false)
    getChangeRoomsDocuments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<ChangeRoomDocumentModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cama' />,
      accessor: 'NomenclaturaCama',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Interlocutor' />,
      accessor: 'Interlocutor',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Huesped' />,
      accessor: 'Huesped',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Email' />,
      accessor: 'Email',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de Envio' />,
      accessor: 'FechaEnvio',
    },
  ]

  return (
    <>
      <KTCard shadow className='m-5'>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <SnackbarProvider />
      </KTCard>
    </>
  )
}

const TableChangeRoomsDocumentsWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>
      {isAllowed('DOCUMENTO/LISTAR') && <TableChangeRoomsDocuments />}
    </KTableProvider>
  )
}

export {TableChangeRoomsDocumentsWrapper}
